import { ref } from 'vue';

const page = 'setup-events';

export default [
    {
        path: '/setup/' + page,
        name: `${page}-main`,
        exact: true,
        component: () => import('@/pages/setup/events/Index'),
        meta: {
            auth: true,
            permission: ['sp.setup.events.access'],
            title: 'Events',
            prefix: `${page}-main`,
            nimbusPageType: 'nav-landing-page'
        },
        children: [
            {
                path: `/setup/events/event-templates-setup`,
                name: `${page}-event-templates-setup`,
                exact: true,
                component: () => import('@/pages/core/events/event_templates/SetupEventTemplateMain.vue'),
                meta: {
                    auth: true,
                    permission: ['sp.setup.events.event-templates.access'],
                    title: 'Event Templates',
                    prefix: `${page}-event-templates-setup`,
                },
            },
            {
                // Event Type Mapping
                path: `/setup/events/event-type-mapping`,
                name: `${page}-event-type-mapping`,
                exact: true,
                component: () => import('@/pages/setup/events/event_type_mapping/EventTypeMappingMain.vue'),
                meta: {
                    auth: true,
                    permission: ['sp.setup.events.event-type-mapping.access'],
                    title: 'Event Type Mapping',
                    prefix: `${page}-event-type-mapping`,
                },
            },
            {
                path: `/setup/events/event-template-mapping`,
                name: `${page}-event-template-mapping`,
                exact: true,
                component: () => import('@/pages/setup/events/event_template_mapping/EventTemplateMappingMain.vue'),
                meta: {
                    auth: true,
                    permission: ['sp.setup.events.event-template-mapping.access'],
                    title: 'Event Template Map',
                    prefix: `${page}-event-template-mapping`,
                },
            }
        ]
    },

];
